export const VIN_CONFLICT_ERROR_CODES = {
  CUSTOMER_VEHICLE_EXISTS: 'CUSTOMER_VEHICLE_EXISTS',
  DEALER_VEHICLE_EXISTS_TRANSFERRABLE: 'DEALER_VEHICLE_EXISTS_TRANSFERRABLE',
  DEALER_VEHICLE_EXISTS_NOT_TRANSFERRABLE: 'DEALER_VEHICLE_EXISTS_NOT_TRANSFERRABLE',
  DEALER_VEHICLE_EXISTS_SAME_LOCATION: 'DEALER_VEHICLE_EXISTS_SAME_LOCATION',
  DEALER_VEHICLE_EXISTS_SAME_COMPANY: 'DEALER_VEHICLE_EXISTS_SAME_COMPANY',
  DEALER_VEHICLE_EXISTS_SAME_COMPANY_NO_LOCATION: 'DEALER_VEHICLE_EXISTS_SAME_COMPANY_NO_LOCATION',
  CUSTOMER_VEHICLE_EXISTS_SOLD_RECENTLY: 'CUSTOMER_VEHICLE_EXISTS_SOLD_RECENTLY'
};
export const MOVED_RESPONSE_MESSAGE = 'moved vehicle to new location!';
export const LOST_RECORDS_REASON_FOUND = {
  MARKED_FOUND_BY_RECOVR: 'markedFoundByRecovr',
  ONSITE_POSITION_RECONCILED: 'onsitePositionReconciled',
  PAIRED_TO_A_VEHICLE: 'pairedToAVehicle'
};
export const LOST_RECORDS_STATUSES = {
  NOT_YET_BILLED: 'notYetBilled',
  BILLED: 'billed',
  FOUND_TO_BE_REFUNDED: 'foundToBeRefunded',
  FOUND_NEVER_BILLED: 'foundNeverBilled',
  FOUND_REFUNDED: 'foundRefunded',
  FOUND: 'found',
  LOST: 'lost'
};
export default {
  VIN_CONFLICT_ERROR_CODES,
  LOST_RECORDS_REASON_FOUND,
  LOST_RECORDS_STATUSES
};